export const map = (v, a, z, b, y) => b + (y - b) * ((v - a) / (z - a))